import { useAppSelector } from "@hooks/store"
import { useReceivedPaymentDetailContext } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/context/ReceivedPaymentDetailContext"
import { removeChargeInstanceDebtor } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/services/PUT/removeChargeInstanceDebtor"
import useCurrentLocation from "@thooks/useCurrentLocation"
import { customNotification } from "@UI/CustomNotification"
import { useCallback, useState } from "react"

export const useExonerateModal = ({ onClose }) => {
    const auth = useAppSelector(state => state.auth)
    const { param } = useCurrentLocation()
    const { getInitialData } = useReceivedPaymentDetailContext()
    const [isLoadingExonerateModal, setIsLoadingExonerateModal] = useState(false)
    const removeChargeInstanceDebtorService = useCallback(async ({ setLoading, record }) => {
        setLoading?.(true)
        try {
            const jsonData = {
                place_id: record.place_id,
                charge_instance_id: param.chargeInstanceId
            }
            await removeChargeInstanceDebtor({ token: auth.idToken, jsonData })            
        } catch (error) {
            setLoading?.(false)
            console.error(error)
            throw new Error('Error al exonerar el usuario')
        }
    }, [auth, param.chargeInstanceId])

    const handleExonerate = async ({ record }) => {
        setIsLoadingExonerateModal(true)
        await removeChargeInstanceDebtorService({ setLoading: setIsLoadingExonerateModal, record })
        await getInitialData({ charge_instance_id: param.chargeInstanceId })
        customNotification({
            notificationType: 'success',
            duration: 2,
            message: 'Usuario exonerado',
            description: 'El usuario ha sido exonerado en este cobro'
        })
        setIsLoadingExonerateModal(false)
        onClose({ isOpen: false, name: 'exonerate' })
    }
    return {
        isLoadingExonerateModal,
        handleExonerate
    }
}